<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>

export default {
    name: 'App',
    data() {
        return {}
    },
    computed: {},
    methods: {}
}
</script>
<style>
body {
    margin: 0;
    background-color: rgb(243.9, 244.2, 244.8)
}

.header-search-box {
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    gap: 10px; /* 元素之间的间隙 */
    justify-content: flex-start; /* 靠左对齐 */
    align-items: center; /* 垂直居中（可选） */
    margin-bottom: 30px;
}

.pagination {
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
}
</style>
<style scoped>


</style>
